import Image from "../common/Image";
// react imports
import { useState, useContext, useMemo, useEffect } from "react";
import { addCommas } from "@persian-tools/persian-tools";

export default function Items({ items }) {
  const [activKey, setActivKey] = useState("");

  return (
    <>
      {items.map((val, ind) => {
        return (
          <>
            {" "}
            <div className="d-flex product-item" key={`basket_item_${ind}`}>
              <div className="p-img2">
                <Image
                  src={val.img}
                  style={{
                    width: "56px",
                    height: "56px",
                    borderRadius: "6px",
                  }}
                ></Image>
              </div>
              <div className="d-flex-column mr-r-12 w-100">
                <div className="title-h5-m title-item">{val.name}</div>
                <div className="d-flex mr-t-8 align-item-center box-items justify-content-between w-100    ">
                  <div className="d-flex">
                    <div className="txt-t3-m">
                      {val.current_count}&nbsp; قیمت:
                    </div>
                    <div className="desc-m mr-r-6">{addCommas(val.price)}</div>
                  </div>
                  <div className="d-flex">
                    <div className="txt-t3-m">موجودی:</div>
                    <div className="desc-m mr-r-4">
                      {addCommas(val.inventory)}
                      گرم
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {ind < items.length - 1 && <div className="line mr-y-12"></div>}
          </>
        );
      })}
    </>
  );
}
